import { colors } from "@dotnet/telematics-design-system";

import { TASK_OVERVIEW_STATUSES } from "../types";

const useStatusColor = () => {
    const { blue500, gray300, green700, orange700 } = colors;

    const getStatusColor = (status: TASK_OVERVIEW_STATUSES) => {
        switch (status) {
            case TASK_OVERVIEW_STATUSES.Completed:
                return green700;
            case TASK_OVERVIEW_STATUSES.CompletedWithErrors:
                return blue500;
            case TASK_OVERVIEW_STATUSES.Failed:
                return orange700;
            default:
                return gray300;
        }
    };

    return { getStatusColor };
};

export { useStatusColor };
